import script from "./import-external-invoices.vue?vue&type=script&setup=true&lang=ts"
export * from "./import-external-invoices.vue?vue&type=script&setup=true&lang=ts"

import "./import-external-invoices.vue?vue&type=style&index=0&id=69870f58&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69870f58"]])

export default __exports__